import React, { useState, useEffect } from 'react'
import HackathonXmlDiffEditor from '../Modules/XmlDiffEditor/HackathonXmlDiffEditor';
import { Dispatch, bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
// import { Surface, SurfaceBackground } from "azure-devops-ui/Surface";
// import { Page } from "azure-devops-ui/Page";
// import { Button } from "azure-devops-ui/Button";
// import { Card } from "azure-devops-ui/Card";
// import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { useNavigate } from "react-router-dom";
import { useSearchParams, useLocation } from 'react-router-dom'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import { getReviewContent, approveHackathonReviewContent, clearApiResponseStatusAction, GetRadioSelectedAction,getHackathonReviewContent,getHackathonReplaceContent } from "../../redux/Actions/PowerDataQuery";
import DevOpsUIConfirmDialog from '../CustomDialog/DevOpsUIConfirmDialog'
import { IAutoHealingSubmitPayload } from '../Interface/Params/IAutoHealingPayload'
// import { MessageCard, MessageCardSeverity } from "azure-devops-ui/MessageCard";
import {  useMsal, useAccount } from "@azure/msal-react";
import { RemediationUsers } from '../../ConfigData/RemediationUsers'
import ErrorDialog from '../CustomDialog/ErrorDialog'
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import {  MessageBarType } from 'office-ui-fabric-react'
import { SubtractUtcTimes, convertUtcToPst } from '../Utilities/CommonFunction'
// import { XmlDiffEditorData5772 } from '../Modules/XmlDiffEditor/TestData'
import HackathonReplaceDialog from '../ReplaceDialog/HackathonReplaceDialog'

import './HackathonBrokenLinkFixer.css'
import { IAutoHealingReplacement } from '../Interface/View/IAutoHealingView';
// import { Observer } from "azure-devops-ui/Observer";
import CustomTabBar from '../Modules/CommonPageContent/CustomTabBar/CustomTabBar';
import IssueCenterPanel from '../IssueCenter/IssueCenterPanel';
import { ChoiceGroup, DefaultButton, PrimaryButton, Stack, MessageBar } from '@fluentui/react';

const actionCreators = {
    approveHackathonReviewContent,
    clearApiResponseStatusAction,
    getHackathonReplaceContent,
    GetRadioSelectedAction,
    getHackathonReviewContent
  };
  
  type DispatchProps = typeof actionCreators;
  
  const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContent: state.reviewContent,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
  });
  
const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

// // Curation area RadioButton
// let FixRadioButton = new ObservableValue<string>("Replace");

// const selectedTabId = new ObservableValue('')

// Confirm dialog form state interface
interface IConfirmDialogState {
    showDialog: boolean,
}

// Replace dialog form state interface
interface IReplaceState {
    showDialog: boolean
}

// Error dialog form state interface
interface IErrorState {
    title: string,
    showDialog: boolean,
    errorMessage: string,
    errorDetail: string,
    errorCategory?: "InputError" | "SystemError" | "UnknownError",
    messageBarType: MessageBarType
}

interface IScanIssueData {
    content?: string;
    context?: string;
    category?: string;
}

/**
 * broken link checker
 * @param props 
 * @returns 
 */
function HackathonBrokenLinkFixer(props: StoreProps & DispatchProps) {
    const { accounts } = useMsal();
    const userAccount = useAccount(accounts[0]);
    const pathArr = useLocation().pathname.split('/')
    // get the url from the query string
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const traceID = search.get('traceID')
    const curationID = search.get('curationID')
    // const jobID = search.get('JobID')

    // set the healing complete params
    let healingCompleteParams: IHealingCompleteParams = {
        reviewType: "",
        requesturl: requesturl,
        fixerPath: pathArr[pathArr.length-1],
        traceID: traceID,
        curationID: curationID,
        completeTitle: "Thank you!"
    }

    const history = useNavigate();

    /** Initialize confirm dialog form state */
    const [confirmDialogState, setConfirmDialogState] = useState<IConfirmDialogState>({
        showDialog: false
    })

    /** Initialize error dialog form state */
    const [errorDialogState, setErrorDialogState] = useState<IErrorState>({
        title: "",
        showDialog: false,
        errorMessage: "",
        errorDetail: "",
        messageBarType: MessageBarType.error
    })

    /** Initialize confirm dialog form state */
    const [replaceDialogState, setReplaceDialogState] = useState<IReplaceState>({
        showDialog: false
    })

    /** Initialize editor data state */
    const [newDiffEditorData, SetNewDiffEditorData] = useState<string>("");
    const [newNavigationDiffEditorData, SetNewNavigationDiffEditorData] = useState<string>("");
    const [newMetaDiffEditorData, SetNewMetaDiffEditorData] = useState<string>("");

    /** Initialize loading state */
    const [isLoading, setIsLoading] = useState<boolean>(false)

    /** Initialize loading replace button state */
    const [showReplaceButton, setShowReplaceButton] = useState<boolean>(false)

    /**
     * Tab bar related
     */
    const [tabGroupNames, setTabGroupNames] = useState<string[]>(['Content'])

    /**
     * 
     */
    const [showReportPanel, setShowReportPanel] = useState<boolean>(false)
    const [issueList, setIssueList] = useState<IScanIssueData[]>([])

    
    // Curation area RadioButton
    const [FixRadioButton, setFixRadioButton] = useState<string>("Replace")
    const [selectedTabId, setSelectedTabId] = useState<string>("")
    
    
    /**
     * Get the content from the api
     */
    useEffect(() => {
        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

        // Load data from API in effect
        const loadData = async () => {
            setIsLoading(true)

            // call the api to get the content
            await props.getHackathonReviewContent(requesturl, traceID, curationID);

            setIsLoading(false)
        }

        loadData();
    }, [])

    /**
     * handle review content change
     */
    useEffect(() => {
        if (props.reviewContent) {
            // When no broken links are detected, redirect to the completion page.
            if (!props.reviewContent?.AutoChangeSummaryHtml || props.reviewContent?.AutoChangeSummaryHtml?.length == 0) {
                healingCompleteParams.reviewType = 'NoBrokenLink'
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }

            console.log('props.reviewContent', props.reviewContent)

            // init tab
            const tabSet = new Set<string>()

            if(props.reviewContent?.NavOriginalText) {
                tabSet.add('Navigation')
                SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            }
            if(props.reviewContent?.OriginalText) {
                tabSet.add('Content')
                SetNewDiffEditorData(props.reviewContent.ChangedText)
            }
            if(props.reviewContent?.MetaOriginalText) {
                tabSet.add('Metadata')
                SetNewMetaDiffEditorData(props.reviewContent.MetaChangedText)
            }

            setTabGroupNames(Array.from(tabSet))

            const reviewContent = props.reviewContent
            const allOrgList = [...reviewContent.ReplacementList, ...reviewContent.MetaReplacementList, ...reviewContent.NavReplacementList]
            const brokenLinks = []
            allOrgList.forEach(item => {
                brokenLinks.push({
                    content: item.BrokenLink,
                    context: item.BrokenLinkText,
                    category: '',
                    status: 'Broken'
                })
            })
            setIssueList(brokenLinks)

            // When the user fixes broken links through autohealing tool and the time for repair has not exceeded 30 minutes, redirect to the completion page.            
            const approveUtcTime = props.reviewContent?.ReviewHistory?.ReviewDate;
            const reviewResult = props.reviewContent.ReviewHistory?.ReviewResult;
            console.log('approveUtcTime', approveUtcTime)
            console.log('reviewResult', reviewResult)
            console.log('props.reviewContent.ReviewHistory?.ReviewResult', props.reviewContent.ReviewHistory?.ReviewResult)
            if (approveUtcTime && (props.reviewContent.ReviewHistory?.ReviewResult === 3 || props.reviewContent.ReviewHistory?.ReviewResult === 4)) {
                const durationUtcTime = SubtractUtcTimes(approveUtcTime)
                if (durationUtcTime < 30) {
                    healingCompleteParams.reviewType = 'NoBrokenLink'
                    healingCompleteParams.completeTitle = "Thank you!"
                    history(`/apps/close`, { state: healingCompleteParams })
                }
            }

            console.log('1111')
            // No permission to access the page
            if (!isRemediationUser()) {
                healingCompleteParams.reviewType = 'NoPermission'
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }

            console.log('2222',reviewResult)
            // Set the review result
            if (reviewResult === 1) {
                // FixRadioButton.value = "Exception";
                setFixRadioButton("Exception");
            }
            else if (reviewResult === 2) {
                // FixRadioButton.value = "ManuallyFix";
                setFixRadioButton("ManuallyFix");
            }
            else if (reviewResult === 3) {
                // FixRadioButton.value = "Approve";   
                setFixRadioButton("Approve");             
            }
            else {
                // FixRadioButton.value = "Replace";
                setFixRadioButton("Replace");
                setShowReplaceButton(true);
            }
        }
    }, [props.reviewContent])

    useEffect(() => {
        if (props.replaceContent) {
            if(FixRadioButton === "Replace"){
                SetNewDiffEditorData(props.replaceContent.ReplacementChangedText)
                // SetNewMetaDiffEditorData(props.replaceContent.MetaReplacementChangedText)
                // SetNewNavigationDiffEditorData(props.replaceContent.ReplacementNavChangedText)
            }else if(FixRadioButton === "Approve"){
                SetNewDiffEditorData(props.reviewContent.ChangedText)
                // SetNewMetaDiffEditorData(props.reviewContent.MetaChangedText)
                // SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            }
        }
    }, [props, props.replaceContent])
    

    /**
     * handle api response change
     */
    useEffect(() => {
        // if (props.apiResponseState && props.apiResponseState?.showErrorDailog) {
        //     const errorTitle = props.apiResponseState.ErrorMessage? 'Error': 'Application Error'
        //     setErrorDialogState({
        //         title: errorTitle,
        //         showDialog: true,
        //         errorMessage: `We were unable to get the content you requested due to an internal server error. Please retry your action or try again later. Error: ${props.apiResponseState.ErrorMessage === undefined? "Web api request timeout." :props.apiResponseState?.ErrorMessage}`,
        //         errorDetail: props.apiResponseState?.ErrorMessage,
        //         messageBarType: MessageBarType.error
        //     })
        // }

    }, [props.apiResponseState])

    /**
     * check if the confirm button is disabled
     * @returns 
     */
    function isConfirmButtonDisabled() {
        // if call api error, disable the confirm button
        if (props.apiResponseState?.ErrorMessage?.length > 0) {
            return true;
        }

        // if auto change summary is empty, disable the confirm button
        if (props.reviewContent?.AutoChangeSummaryHtml?.length <= 0) {
            return true;
        }

        if (!isRemediationUser()) {
            return true;
        }

        return false;
    }

    /**
     * Set the approve area RadioButtons value
     * @param buttonId radio button id
     */
    function onFixOpionSelect(buttonId: string) {
        // FixRadioButton.value = buttonId;
        setFixRadioButton(buttonId)
        if(buttonId === "Replace")
        {
            setShowReplaceButton(true);
            setReplaceDialogState({
                showDialog: true
            })
        }else{
            setShowReplaceButton(false);
            setReplaceDialogState({
                showDialog: false
            })
        }

        props.GetRadioSelectedAction(buttonId);
    };

    /**
     * Handle replace click
     */
    function handleReplaceClick() {
        if (FixRadioButton === "Replace") {
            setReplaceDialogState({
                showDialog: true
            })
        } 
    }

    /**
     * Handle confirm click
     */
    function handleConfirmClick() {
        // "I approve this change. Publish the updated file and resolve this ticket." selected
        if (FixRadioButton === "Approve" || FixRadioButton === "Replace") {
            setConfirmDialogState({
                showDialog: true
            })
        } else {
            // Submit the changes.
            SubmitChange()

            healingCompleteParams.reviewType = FixRadioButton
            healingCompleteParams.completeTitle = "Thank you!"
            history(`/apps/close`, { state: healingCompleteParams })
        }
    }

    /**
     * Handle the diff editor change
     * @param value 
     */
    function onDiffEditorChange(type: string, value: string) {
        if(type === 'Navigation') {
            SetNewNavigationDiffEditorData(value)
        }
        if(type === 'Content') {
            SetNewDiffEditorData(value)
        }
        if(type === 'Metadata') {
            SetNewMetaDiffEditorData(value)
        }
    }

    /**
     * handle the confirm dialog dismiss
     */
    function onConfirmDialogDismiss() {
        setConfirmDialogState({
            showDialog: false
        })
    }

    /**
     * handle the replace dialog dismiss
     */
    function onReplaceDialogDismiss() {
        setReplaceDialogState({
            showDialog: false
        })
    }

    /**
     * handle the error dialog dismiss
     */
    function onErrorDialogDismiss() {
        //props.clearApiResponseStatusAction()
        setErrorDialogState({
            ...errorDialogState,
            showDialog: false
        })

        healingCompleteParams.reviewType = "Close"
        healingCompleteParams.completeTitle = "Thank you!"
        history(`/apps/close`, { state: healingCompleteParams })
    }

    /**
     * handle the confirm dialog submit
     */
    function SubmitChange() {
        const reason = arguments.length>0 ?arguments[0]:'';
        let reviewResult = 1;
        if (FixRadioButton === "ManuallyFix") {
            reviewResult = 2;
        }
        else if (FixRadioButton === "Approve") {
            reviewResult = 3;
        }else if (FixRadioButton === "Replace") {
            reviewResult = 4;
        }

        // submit the changes
        let approveParams: IAutoHealingSubmitPayload = {
            KBID: props.reviewContent?.KBID,
            RepoId: props.reviewContent?.RepoId,
            DdueContent: newDiffEditorData,
            NavJsonContent: newNavigationDiffEditorData,
            MetaContent: newMetaDiffEditorData,
            OriginalMetaContent: props.reviewContent?.MetaOriginalText,
            OriginalNavJsonContent: props.reviewContent?.NavOriginalText,
            NavC3FilePath: props.reviewContent?.NavC3FilePath,
            NavMetadataFilePath: props.reviewContent?.NavMetadataFilePath,
            NavRepoId: props.reviewContent?.NavRepoId,
            OriginalDdueContent: props.reviewContent?.OriginalText,
            Link: props.reviewContent?.Link,
            TraceID: props.reviewContent?.TraceID,
            OrganizationName: props.reviewContent?.OrganizationName,
            ProjectName: props.reviewContent?.ProjectName,
            TicketId: props.reviewContent?.TicketId,
            CurationID: props.reviewContent?.CurationID,
            JobID: props.reviewContent?.JobID,
            TicketCreatedDate: props.reviewContent?.TicketCreatedDate,
            ReviewResult: reviewResult,
            Reason: reason? reason:"Auto-Healing",
            ChangeHistoryOrNot: reason? true: false,
            C3FilePath: props.reviewContent?.C3FilePath,
            MetadataFilePath: props.reviewContent?.MetadataFilePath,
            RequiredAlias: props.reviewContent?.RequiredAlias,
            OptionalAlias: props.reviewContent?.OptionalAlias,
            ManagerAlias: props.reviewContent?.ManagerAlias,
            AutoHealingType: props.reviewContent?.AutoHealingType
        }

        props.approveHackathonReviewContent(approveParams);

        if (FixRadioButton === "Approve" || FixRadioButton === "Replace") {
            setConfirmDialogState({
                showDialog: false
            })

            healingCompleteParams.reviewType = FixRadioButton
            healingCompleteParams.completeTitle = "Congratulations!"
            history(`/apps/close`, { state: healingCompleteParams })
        }
    }

    /**
     * check if the user is in the remediation user list
     * @returns 
     */
    function isRemediationUser() {
        let userExsit = RemediationUsers.find((userItem) => userItem.userName === userAccount.username)
        if (userAccount.username !== props.reviewContent?.RequiredAlias &&
            userAccount.username !== props.reviewContent?.OptionalAlias &&
            userAccount.username !== props.reviewContent?.ManagerAlias &&
            !userExsit) {
            return false;
        }

        return true;
    }

    /**
     * handle the cancel click
     */
    function handCancelClick() {
        healingCompleteParams.reviewType = "Close"
        healingCompleteParams.completeTitle = "Thank you!"
        history(`/apps/close`, { state: healingCompleteParams })
    }

    async function replaceChange(replacementContent: IAutoHealingReplacement) {
        try {
          setIsLoading(true);
          await props.getHackathonReplaceContent(replacementContent);
          setIsLoading(false);
        } catch (error) {
          console.error("API Error:", error);
        }
      }

    /**
     * render the review history
     * @returns 
     */
    function renderReviewHistory() {
        if (!props.reviewContent || !props.reviewContent?.ReviewHistory) {
            return null;
        }

        const { Reviewer, ReviewDate } = props.reviewContent?.ReviewHistory;

        let message: string = "";
        console.log(props.reviewContent?.ReviewHistory?.ReviewResult)
        switch (props.reviewContent?.ReviewHistory?.ReviewResult) {
            // Exception
            case 1:
                message = `${Reviewer} has not approved the changes and does not want any action to be taken on this article on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // ManuallyFix
            case 2:
                message = `${Reviewer} will work on the issue manually and does not want any automated changes to be made at this time on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // Approve
            case 3:
                message = `${Reviewer} has approved the changes to republish the article and close this ticket on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // Replace
            case 4:
                message = `${Reviewer} has approved the changes to republish the article and close this ticket on ${convertUtcToPst(ReviewDate)}.`;
                break;
        }

        return (
            <>
                {/* <MessageCard
                    className="flex-self-stretch autohealing-review-history"
                    onDismiss={null}
                    severity={MessageCardSeverity.Warning}
                >
                    {message}
                </MessageCard> */}
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    isMultiline={false}
                    className="flex-self-stretch autohealing-review-history"
                    styles={{
                        root: {
                            backgroundColor: '#fff4ce',
                            borderRadius: 6,
                            boxShadow: '0 1.6px 3.6px rgba(0,0,0,0.132), 0 0.3px 0.9px rgba(0,0,0,0.108)',
                            padding: '12px 16px',
                            fontSize: 14,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                        },
                        icon: {
                            fontSize: 16,
                        },
                        text: {
                            lineHeight: '20px',
                        }
                    }}
                >
                    {message}
                </MessageBar>
                <div className="flex-grow">
                    <br />
                </div>
            </>
        );
    }

    return (
        <div style={{ width: "100%" }}>
            <div className="flex-grow">
                <br />
            </div>
            {/* <Surface background={SurfaceBackground.neutral}>
                <Page className="pipelines-page"> */}
                <Stack className="pipelines-page" style={{backgroundColor:"rgba( var(--palette-neutral-2,248, 248, 248) ,  1 )"}} tokens={{ childrenGap: 16 }} styles={{ root: { padding: 16 } }}>
                    <div className="page-content page-content-top">
                        {
                            tabGroupNames.length > 1 ?
                                <>
                                    <CustomTabBar
                                        tabGroupNames={tabGroupNames}
                                        onSelectChange={tabId => setSelectedTabId(tabId)}
                                    />
                                    <Stack tokens={{ childrenGap: 8 }} className="customCard">
                                        <HackathonXmlDiffEditor type={selectedTabId} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton} />
                                    </Stack>
                                    {/* <Observer selectedTabId={selectedTabId}>
                                        {(props: { selectedTabId: string }) => {
                                            return (
                                                <Card>
                                                    <HackathonXmlDiffEditor type={props.selectedTabId} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton} />
                                                </Card>
                                            )
                                        }}
                                    </Observer> */}
                                </> :
                                <Stack tokens={{ childrenGap: 8 }} className="customCard">
                                    <HackathonXmlDiffEditor type={tabGroupNames[0]} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton} />
                                </Stack>
                                // <Card>
                                //     <HackathonXmlDiffEditor type={tabGroupNames[0]} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton} />
                                // </Card>
                        }
                        <div className="flex-grow">
                            <br />
                        </div>
                        {renderReviewHistory()}

                        {/* <Card className="flex-grow approveOpption"> */}
                        <Stack tokens={{ childrenGap: 8 }} className="customCard">
                            <div className="flex-row approveOpption" style={{ flexWrap: "wrap" }}>
                                <div className="flex-column" >
                                    <div>The <a href='https://aka.ms/ACCTUserGuide'>Microsoft Automated, Configurable, and Extensible Digital Asset Curation Tool</a> (aka "Sonic") has identified a quality issue in this article and auto-engaged the <a href='https://aka.ms/Autohealing'>Microsoft Digital Asset Self-Healing Tool</a> (aka "Chiron"). Chiron can assist you with quickly resolving this content-quality issue by taking automated actions on your behalf. Please review the options below.
                                    </div>
                                    {/* <RadioButtonGroup className="flex-grow"
                                        selectedButtonId={FixRadioButton}
                                        onSelect={onFixOpionSelect}
                                    >
                                        <RadioButton disabled={!isRemediationUser()} id="Approve" text="Yes, I want to resolve the issue and agree with the proposed change to remove the broken link(s) while keeping the link text(s). Automatically pull the article files, apply and merge the change, republish the article, and resolve this ticket with all applicable actions recorded. " key="Approve" />
                                        <RadioButton disabled={!isRemediationUser()} id="Replace" text="Yes, I want to resolve the issue by personally substituting the broken links with a functional one. Open the relevant link replacement canvas." key="Replace" ><Button primary={showReplaceButton} text="Replace the bad links" onClick={handleReplaceClick} disabled={!showReplaceButton}/></RadioButton>
                                        <RadioButton disabled={!isRemediationUser()} id="ManuallyFix" text="Yes, I want to resolve the issue but not in the way proposed. Open it in the relevant authoring canvas." key="ManuallyFix" />
                                        <RadioButton disabled={!isRemediationUser()} id="Exception" text="No, I do not want to resolve this content-quality issue. Take no further action on this article and resolve this ticket. (Please note that your decision to leave this 404-generating hyperlink in the article will be recorded.)" key="Exception" />
                                    </RadioButtonGroup> */}

                                    <ChoiceGroup
                                        selectedKey={FixRadioButton}
                                        onChange={(_, option) => onFixOpionSelect(option?.key)}
                                        options={[
                                            {
                                                key: 'Approve',
                                                text: 'Yes, I want to resolve the issue and agree with the proposed change to remove the broken link(s) while keeping the link text(s). Automatically pull the article files, apply and merge the change, republish the article, and resolve this ticket with all applicable actions recorded.',
                                                disabled: !isRemediationUser(),
                                            },
                                            {
                                                key: 'Replace',
                                                text: 'Yes, I want to resolve the issue by personally substituting the broken links with a functional one. Open the relevant link replacement canvas.',
                                                onRenderField: (props, render) => (
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        {render!(props)}
                                                        <PrimaryButton
                                                            text="Replace the bad links"
                                                            onClick={handleReplaceClick}
                                                            disabled={!showReplaceButton || !isRemediationUser()}
                                                            style={{ marginTop: 8, marginLeft: 24 }}
                                                        />
                                                    </div>
                                                ),
                                                disabled: !isRemediationUser(),
                                            },
                                            {
                                                key: 'ManuallyFix',
                                                text: 'Yes, I want to resolve the issue but not in the way proposed. Open it in the relevant authoring canvas.',
                                                disabled: !isRemediationUser(),
                                            },
                                            {
                                                key: 'Exception',
                                                text: 'No, I do not want to resolve this content-quality issue. Take no further action on this article and resolve this ticket. (Please note that your decision to leave this 404-generating hyperlink in the article will be recorded.)',
                                                disabled: !isRemediationUser(),
                                            },
                                        ]}
                                        styles={{ root: { flexGrow: 1 } }}
                                    />

                                </div>
                            </div>
                            <div className="flex-column" style={{ flexWrap: "wrap", marginTop: "20px" }}>                               
                                <div className="flex-row">
                                    <div style={{ display: "flex", alignSelf: "center" }}>
                                        If you need to report a false positive case or request an exception, please click on
                                    </div> 
                                    {/* <Button text=" Submit exceptions/false positive cases"
                                        primary={true}
                                        className='exception-report-btn'
                                        disabled={isConfirmButtonDisabled()}
                                        onClick={ () => {setShowReportPanel(true)} } /> */}
                                    <PrimaryButton
                                        text=" Submit exceptions/false positive cases"
                                        className="exception-report-btn"
                                        disabled={isConfirmButtonDisabled()}
                                        onClick={() => setShowReportPanel(true)}
                                    />
                                </div>
                                <div className="flex-column" style={{marginTop: '10px'}}>
                                    If you have any questions about Sonic, Chiron, or the proposed change above, please click <a style={{ display: "contents" }} href='https://aka.ms/Chironsupport'>here</a> to create a ticket for assistance.
                                    {/* If you have any questions about Sonic, Chiron, or the proposed change above, please contact <a style={{ display: "contents" }} href='mailto:rayring@microsoft.com'>Ray Ringhiser </a>(rayring@microsoft.com) in the CE&S Knowledge Management team. */}
                                </div>
                            </div>
                        </Stack>
                        <div className="flex-grow">
                            <br />
                        </div>
                        {/* <Card>
                            <div>
                                <ButtonGroup className="flex-wrap">
                                    <Button text="Confirm"
                                        primary={true}
                                        disabled={isConfirmButtonDisabled()}
                                        onClick={handleConfirmClick} />
                                    <Button text="Close" onClick={handCancelClick} />
                                </ButtonGroup>
                            </div>
                        </Card> */}
                        <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ marginBottom: "50px" }}>
                            <div>
                                <Stack horizontal wrap tokens={{ childrenGap: 8 }}>
                                    <PrimaryButton
                                        text="Confirm"
                                        onClick={handleConfirmClick}
                                        disabled={isConfirmButtonDisabled()}
                                    />
                                    <DefaultButton
                                        text="Close"
                                        onClick={handCancelClick}
                                    />
                                </Stack>
                            </div>
                        </Stack>
                    </div>
                </Stack>
            {/* </Surface> */}
            <>
              {showReplaceButton &&  
              <HackathonReplaceDialog
                    title={'Replace the bad links'}
                    replaceContent={props.replaceContent}
                    reviewContent={props.reviewContent}
                    showDialog={replaceDialogState.showDialog}
                    onReplaceDialogDismiss={onReplaceDialogDismiss}
                    onReplaceDialogApply={replaceChange}
                    algorithmType='BrokenLink'
                />} 
                <DevOpsUIConfirmDialog
                    title={'Confirmation'}
                    content='You are about to approve this change, click Approve, it will publish the change and resolve the ticket.'
                    ccid={props.reviewContent?.CIID}
                    showDialog={confirmDialogState.showDialog}
                    onConfirmDialogDismiss={onConfirmDialogDismiss}
                    onConfirmDialogSubmit={SubmitChange}
                />
                <ErrorDialog
                    title={errorDialogState.title}
                    errorMessage={errorDialogState.errorMessage}
                    // showErrorDialog={props.apiResponseState?.showErrorDailog}
                    showErrorDialog={errorDialogState.showDialog}
                    apiUrl={props.apiResponseState?.ApiUrl}
                    detailErrorMessage={errorDialogState.errorDetail}
                    messageBarType={errorDialogState.messageBarType}
                    onErrorDialogDismiss={onErrorDialogDismiss}
                />
                {
                    isLoading && <Spinner className='autohealing-loading' label='Loading...' size={SpinnerSize.large} />
                }
            </>
            <IssueCenterPanel
                title='Content Issues'
                showPanel={showReportPanel}
                onDismiss={() => { setShowReportPanel(false) }}
                originalIssueList={issueList}
             />
        </div>
    )
}

export default connect<StoreProps, DispatchProps>(
  mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(HackathonBrokenLinkFixer);
